import { Heading } from '@chakra-ui/react';

const Header = () => (
  <Heading>Campanhas</Heading>
);

export default Header;
